import { DialogM } from "@common/components/alert/dialog/Dialog"
import { PlaySoundM } from "@common/components/playSound/PlaySoundM"
import TextM from "@common/components/text/TextM"
import { MuteCurrentUser } from "../../../engine/live/room/MuteCurrentUser"
import ConnectionQualityAlert from "@common/livekit/components/ConnectionQualityAlert"
import InformationBarComponent from "@common/livekit/components/InformationBarComponent"
import LiveKitStatsMonitor from "@common/livekit/components-web/LiveKitStatsMonitor.web"
import { useApiStatus } from "@common/hooks/useApiStatus"
import { useDisconnecting } from "@common/livekit/components/useDisconnecting"
import LiveParticipant from "@common/liveMode/liveV3/LiveParticipant"
import LiveWebMobileBanner, {
    liveWebMobileBannerHeight,
    useLiveWebMobileBannerCollapsed,
} from "@common/liveMode/LiveWebMobileBanner"
import { availableGridHeight } from "@common/liveMode/liveV3/tutorGridLayout"
import { theme } from "@common/theme/theme"
import { DimensionsContext } from "@common/utils/mobileUtils"
import { ConnectingView } from "@common/video-call/ConnectingView"
import PermissionsManager from "@common/video-call/PermissionsManager"
import { apiIdle, apiRequest } from "@data/redux/actions/api"
import {
    setIsLiveModeEnabled,
    setFocusScreenShare,
} from "@data/redux/actions/liveMode"
import { setMuteVideo } from "@data/redux/actions/videoCall"
import { liveService } from "@data/services/liveService"
import { liveServiceV2 } from "@data/services/liveServiceV2"
import LiveEventBuffer from "@data/services/LiveEventBuffer"
import { useInitialCamRecord } from "../../../engine/live/room/useInitialCamRecord"
import { useLiveKitWebReconnect } from "../../../engine/live/room/useLiveKitWebReconnect"
import { hasRole } from "@data/utility/ability"
import {
    useConnectionState,
    useRoomContext,
    useTracks,
} from "@livekit/components-react"
import { useNavigation, useRoute } from "@react-navigation/native"
import { ConnectionState, Track } from "livekit-client"
import moment from "moment"
import React, { useCallback, useContext, useEffect, useMemo, useState } from "react"
import { Dimensions, View } from "react-native"
import { useSafeAreaInsets } from "react-native-safe-area-context"
import { connect } from "react-redux"
import {
    selectInCallUsers,
    selectLiveParticipants,
    selectLiveTutors,
} from "@data/redux/selectors/liveModeSelectors"
import { findClosestNextOccurrence } from "../../../student/account/onboarding/LiveRoomCard"
import LiveModeFooter from "../../header/LiveModeFooter"
import TutorRoomView from "./TutorRoomView"
import { IS_WEB } from "@common/utils/mobileUtils"
import TutorEventsPanel, {
    useTutorEventsPanelEnabled,
} from "./tutorEventsPanel/TutorEventsPanel"

const NotificationMessage = ({ message, dimensions }) => (
    <View
        style={{
            flexDirection: "row",
            alignItems: "center",
            justifyContent: dimensions.width > 800 ? "center" : "flex-start",
            width: Dimensions.get("window").width,
            paddingVertical: 3,
            paddingHorizontal: 10,
            marginBottom: 5,
        }}
    >
        <View
            style={{
                width: "100%",
                padding: 10,
                backgroundColor: theme.colors.errorLight,
                borderRadius: 10,
            }}
        >
            <TextM wrap style={{ textAlign: "center" }}>
                {message}
            </TextM>
        </View>
    </View>
)

const TutorLiveScreen = (props) => {
    const insets = useSafeAreaInsets()
    const [pinnedMode, setPinnedMode] = useState(false)
    const [pinnedParticipantId, setPinnedParticipantId] = useState(null)
    const [pinnedTrackSid, setPinnedTrackSid] = useState(null)
    const isFocusScreenShare = props.isFocusScreenShare

    // Wrap setPinnedMode: confirm before switching to grid when presenting
    const safePinnedMode = (value) => {
        if (pinnedMode && !value && isFocusScreenShare) {
            DialogM.show({
                text1: "Interrompre la présentation ?",
                text2: "Le partage d'écran sera arrêté si tu quittes cette vue.",
                buttonText1: "Interrompre",
                buttonColor1: theme.colors.error,
                onPress: () => {
                    props.setFocusScreenShare(false)
                    setTimeout(() => setPinnedMode(false), 300)
                },
                buttonText2: "Rester",
            })
            return
        }
        setPinnedMode(value)
    }

    const liveSession = props.liveSessions?.find(
        (x) => x?.id === props.liveSessionId
    )
    const users = liveSession?.users

    const tutor = liveSession?.users?.find((l) => l?.is_tutor)

    const room = useRoomContext()
    const token = props.roomData?.token

    const connectionState = useConnectionState()

    const isConnected = connectionState === "connected"
    const disconnecting = useDisconnecting()

    // Le tuteur a son propre écran de live : `LKVideoCallPortal` n'est monté
    // que pour les élèves. Sans ce filet ici, une room tuteur arrêtée n'était
    // relancée par personne — l'écran restait sur « Connexion… », avec pour
    // seule issue « Annuler », qui fait quitter la séance.
    const webReconnect = useLiveKitWebReconnect(
        room,
        props.roomData,
        props.otherTabPresent
    )

    const [isDenied, setIsDenied] = useState(IS_WEB)
    // Au natif, pas de capture de test : les questions sont posées avant la salle (`useTutorMediaAccessGate`).
    const [permissionsChecked, setPermissionsChecked] = useState(!IS_WEB)

    const navigation = useNavigation()
    const route = useRoute()

    const isSoundMode =
        hasRole(props.user, "student") &&
        props.soundModeIds?.includes(props.user?.id)

    const isTutor = hasRole(props.user, "tutor")

    useApiStatus(
        liveServiceV2.setSoundModeV2,
        false,
        true,
        () => {}
    )

    // useInterval(() => {
    //     DialogM.show({
    //         champion: "sam",
    //         variant: "main",
    //         text1: "Alison a besoin d'aide",
    //         text2: "J'ai l'impression qu'elle s'est trompée à son exercice et qu'elle n'avance pas",
    //         buttonText1: "Parler à Alison",
    //         buttonColor1: theme.colors.success,
    //         onPress: () => {},
    //         buttonText2: "Annuler",
    //         exitButton: true
    //     });
    // }, 10*1000)

    // Le retry de 6 s qui vivait ici est supprimé : il détruisait la reprise de
    // LiveKit. La reconnexion appartient au seul SDK — voir `roomOptions.js`.

    useEffect(() => {
        props.apiRequest(liveServiceV2.joinCallV2, { id: props.liveSessionId })

        // Initialize the event buffer for batched event syncing
        LiveEventBuffer.getInstance().init(props.liveSessionId, props.user?.id)

        return () => {
            props.apiRequest(liveServiceV2.leaveCallV2, {
                id: props.liveSessionId,
            })
            // Destroy buffer (flushes remaining events to backend)
            LiveEventBuffer.getInstance().destroy()
            room.disconnect(true)
                .then()
                .catch((reason) => {
                    console.log("DISCONNECT ERROR LIVEKIT", reason)
                })
        }
    }, [])

    useInitialCamRecord(isConnected, room)

    const playJoinSound = () => {
        PlaySoundM.play(require("@assets/sounds/maximize_001_low.mp3"))
    }

    const playLeaveSound = () => {
        PlaySoundM.play(require("@assets/sounds/minimize_001_low.mp3"))
    }

    const dimensions = useContext(DimensionsContext)

    // Tracks for the self-overlay LiveParticipant
    const allTracks = useTracks(
        [
            { source: Track.Source.Camera, withPlaceholder: true },
            { source: Track.Source.ScreenShare, withPlaceholder: false },
        ],
        { onlySubscribed: true }
    )

    const selfTracks = useMemo(
        () =>
            allTracks?.filter(
                (track) =>
                    track.participant.identity?.split(".")?.[0] ===
                    props.user?.id?.toString()
            ) ?? [],
        [allTracks, props.user?.id]
    )

    const bgColor = isTutor
        ? theme.colors.grey
        : isSoundMode
          ? theme.colors.success
          : theme.colors.purple

    const isSilentMode =
        !props.soundModeIds?.includes(props.user?.id) &&
        hasRole(props.user, "student")

    const localParticipant = room?.localParticipant

    const [showInformationBar, setShowInformationBar] = useState(false)

    const footerHeight = 70 + insets.bottom

    // Le bandeau web mobile vit dans le flux : sa hauteur est retirée de la place
    // laissée à la grille, sinon le footer se retrouve poussé hors de l'écran.
    // Cet écran sert aussi les tuteurs en natif, où le bandeau n'existe pas :
    // la sortie est explicite ici plutôt que déduite d'un garde distant.
    const bannerCollapsed = useLiveWebMobileBannerCollapsed()
    const appBannerHeight = IS_WEB
        ? liveWebMobileBannerHeight(bannerCollapsed)
        : 0

    const availableWindowHeight = availableGridHeight({
        windowHeight: Dimensions?.get("window")?.height,
        footerHeight,
        insetTop: insets.top,
        showInformationBar,
        bannerHeight: appBannerHeight,
    })

    const studentParticipants = useMemo(
        () => liveSession?.users?.filter((user) => !user?.is_tutor) ?? [],
        [liveSession?.users],
    )

    const tutorEventsPanelEnabled = useTutorEventsPanelEnabled()

    useEffect(() => {
        if (!tutorEventsPanelEnabled) return
        if (!pinnedParticipantId && studentParticipants?.[0]?.id) {
            setPinnedParticipantId(studentParticipants[0].id)
        }
    }, [tutorEventsPanelEnabled, pinnedParticipantId, studentParticipants])

    const handlePinStudent = useCallback((studentId) => {
        setPinnedParticipantId(studentId)
        setPinnedTrackSid(null)
        setPinnedMode(true)
    }, [])

    const didAnyStudentConnect =
        props.todayLiveSessionLogs?.filter(
            (log) =>
                log?.action === "get_live_session" &&
                studentParticipants
                    ?.map((c) => c?.id)
                    ?.includes(log?.user_id) &&
                moment(log?.created_at)?.isSameOrAfter(
                    liveMoment.clone().subtract(15, "minutes")
                )
        )?.length > 0

    const closestNextOccurrence = findClosestNextOccurrence([liveSession])
    const liveMoment = closestNextOccurrence?.date
        ? moment(closestNextOccurrence?.date)
        : null
    const tutorParticipants =
        liveSession?.users?.filter((user) => user?.is_tutor) ?? []
    const presentStudents =
        studentParticipants?.filter((user) =>
            props.participants?.includes(user?.id)
        ) ?? []
    const participants = liveSession?.users

    const showNoStudentsConnectedMessage =
        studentParticipants?.length > 0 &&
        presentStudents?.length === 0 &&
        !didAnyStudentConnect &&
        liveSession?.live_room?.type !== "trial" &&
        liveMoment?.isBefore(moment()?.subtract(3, "minutes"))

    return (
        <View
            style={{
                flex: 1,
            }}
        >
            {/* Rappel permanent en web mobile : un live ne s'anime pas
                correctement depuis le navigateur d'un téléphone */}
            {IS_WEB && <LiveWebMobileBanner />}
            <View
                style={{
                    flex: 1,
                    backgroundColor: theme.colors.lighter,
                }}
            >
                {isConnected && !!token && permissionsChecked && (
                    <View style={{ flex: 1 }}>
                        {/* Mute local mic when soundMode is off */}
                        <MuteCurrentUser
                            isSilentMode={!isSoundMode && !isTutor}
                        />
                        {/* Your custom component with basic video conferencing functionality. */}
                        <View style={{ flex: 1, paddingTop: insets.top + 10 }}>
                            {studentParticipants?.length > 0 ? (
                                showNoStudentsConnectedMessage && (
                                    <NotificationMessage
                                        dimensions={dimensions}
                                        message="Aucun élève connecté pour le moment. Les parents sont notifiés automatiquement au bout de 5 minutes. Si tu n'as aucune nouvelle au bout de 20 minutes, tu peux clôturer le live."
                                    />
                                )
                            ) : (
                                <NotificationMessage
                                    dimensions={dimensions}
                                    message="Aucun élève inscrit sur cette session."
                                />
                            )}
                            {/* Lift pin-state only for pilot rooms; other tutors
                                keep TutorRoomView's own local state (unchanged). */}
                            <TutorRoomView
                                pinnedMode={pinnedMode}
                                availableWindowHeight={availableWindowHeight}
                                setPinnedMode={safePinnedMode}
                                {...(tutorEventsPanelEnabled && {
                                    pinnedParticipantId,
                                    setPinnedParticipantId,
                                    pinnedTrackSid,
                                    setPinnedTrackSid,
                                })}
                            />
                        </View>
                        <ConnectionQualityAlert />
                        {/* Stats monitor for dev - logs to console */}
                        {/* {__DEV__ && IS_WEB && <LiveKitStatsMonitor />} */}
                    </View>
                )}
                {(!isConnected || !token) && (
                    <ConnectingView
                        width={Dimensions?.get("window")?.width}
                        height={"100%"}
                        onRetry={webReconnect.onRetry}
                        isRetrying={webReconnect.isRetrying}
                        text={
                            connectionState?.toString() ===
                            ConnectionState.Reconnecting
                                ? "Reconnexion..."
                                : disconnecting
                                  ? "Déconnexion..."
                                  : "Connexion..."
                        }
                        onPress={() => {
                            props.apiRequest(liveService.leaveLiveSession, {
                                id: props.liveSessionId,
                            })
                        }}
                    />
                )}
            </View>
            <View>
                <InformationBarComponent
                    isSilentMode={!isSoundMode && !isTutor}
                    showBar={showInformationBar}
                    setShowBar={setShowInformationBar}
                />
                <LiveModeFooter
                    pinnedMode={pinnedMode}
                    height={footerHeight}
                    setPinnedMode={safePinnedMode}
                />
            </View>
            <LiveParticipant
                user={participants?.find((x) => x?.id === props.user?.id)}
                userTracks={selfTracks}
                style={{
                    position: "absolute",
                    bottom:
                        dimensions?.width < 700 || tutorEventsPanelEnabled
                            ? footerHeight
                            : 0,
                    right: 0,
                    width: dimensions?.width < 700 ? 80 : 160,
                    height: dimensions?.width < 700 ? 120 : 100,
                }}
                containerStyle={{
                    borderTopLeftRadius: 15,
                    borderTopWidth: 1,
                    borderLeftWidth: 1,
                }}
            />
            {tutorEventsPanelEnabled && isTutor && isConnected && (
                <TutorEventsPanel
                    liveSessionId={props.liveSessionId}
                    students={studentParticipants}
                    currentUser={props.user}
                    footerHeight={footerHeight}
                    onPinStudent={handlePinStudent}
                />
            )}
            {IS_WEB && (
                <PermissionsManager
                    isDenied={isDenied}
                    setIsDenied={setIsDenied}
                    permissionsChecked={permissionsChecked}
                    setPermissionsChecked={setPermissionsChecked}
                />
            )}
        </View>
    )
}

const mapStateToProps = (state) => {
    return {
        user: state.data.currentUser?.object,
        participants: selectLiveParticipants(state),
        tutors: selectLiveTutors(state),
        liveSessions: state.data.currentUser?.object?.live_sessions,
        liveSessionId: state.liveMode?.liveSessionId,
        inCallUsers: selectInCallUsers(state),
        soundModeIds: state.liveMode?.soundModeIds,
        roomData: state.liveKitRoom?.roomData,
        isVideoMuted: state.liveMode?.isVideoMuted,
        leaveLiveSessionRequest: state.api.leaveLiveSession?.request,
        activityPaused: state.activity?.activityPaused,
        isFocusScreenShare: state.liveMode?.isFocusScreenShare,
    }
}

const mapDispatchToProps = {
    apiRequest,
    apiIdle,
    setIsLiveModeEnabled,
    setMuteVideo,
    setFocusScreenShare,
}
export default connect(mapStateToProps, mapDispatchToProps)(TutorLiveScreen)
